import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Text } from 'foundations-components/components/Text';
import { useSearchParams } from '../../hooks/useSearchParams';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchResultsHeader() {
  const searchParams = useSearchParams();
  if (!searchParams.get('search')) return undefined;
  return /*#__PURE__*/_jsx(Text, {
    as: "h1",
    typography: "heading-400",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "marketplaceStorefront.searchResults.header.resultsForQuery_jsx",
      elements: {
        Strong: props => /*#__PURE__*/_jsx("span", Object.assign({
          style: {
            fontWeight: 700
          }
        }, props))
      },
      options: {
        query: searchParams.get('search')
      }
    })
  });
}